import React from "react";
import { FieldRendererProps } from "../types";
import { TextArea } from "../../../ui/index.ts";
import styles from "./shared.module.css"
import clsx from "clsx";

const PROBATION_TEXT_MAX_LENGTH = 2000;

export default function TextFieldRenderer({ question, field, readOnly, index }: FieldRendererProps) {
    if (readOnly) {
        return <div className={styles.wrapper}>
            <label className={clsx(
                "sub-heading-md",
                styles.label)} htmlFor={field.name}>{question.question}</label>
            <p className={clsx("body-sm", styles.value)}>{field.state.value}</p>
        </div>;
    }

    const label = (index ?? false) !== false ? `${index}.  ${question.question}` : question.question;
    return (
        <TextArea
            id={field.name}
            maxLength={PROBATION_TEXT_MAX_LENGTH}
            showCharacterCount
            label={label}
            value={field.state.value}
            onChange={(e) => field.handleChange(e.target.value)}
            onBlur={field.handleBlur}
            error={field.state.meta.errors?.[0]?.message?.toString()}
            readOnly={readOnly}
            placeholder="Type your response here..."
        />
    );
}